/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Admin Console
 * Mercatus Admin Console
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateUserRequest } from '../model';
// @ts-ignore
import { OrgSettingsResponse } from '../model';
// @ts-ignore
import { UpdateUserRequest } from '../model';
// @ts-ignore
import { UserDetailResponse } from '../model';
// @ts-ignore
import { UserListItemResponse } from '../model';
// @ts-ignore
import { UserStatusUpdateRequest } from '../model';
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new user.
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (createUserRequest: CreateUserRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserRequest' is not null or undefined
            assertParamExists('createUser', 'createUserRequest', createUserRequest)
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the effective organization\'s user administration settings.
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgSettings: async (orgId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/org-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orgId !== undefined) {
                localVarQueryParameter['__orgId__'] = orgId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get detailed user information by ID.
         * @param {number} id User ID
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (id: number, orgId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUser', 'id', id)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orgId !== undefined) {
                localVarQueryParameter['__orgId__'] = orgId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all users for the authenticated user\'s organization.
         * @param {number} [orgId] Overrides the organization context for org 1 admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (orgId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orgId !== undefined) {
                localVarQueryParameter['__orgId__'] = orgId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing user.
         * @param {number} id User ID
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (id: number, updateUserRequest: UpdateUserRequest, orgId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUser', 'id', id)
            // verify required parameter 'updateUserRequest' is not null or undefined
            assertParamExists('updateUser', 'updateUserRequest', updateUserRequest)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orgId !== undefined) {
                localVarQueryParameter['__orgId__'] = orgId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable or disable a user.
         * @param {number} id User ID
         * @param {UserStatusUpdateRequest} userStatusUpdateRequest 
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStatus: async (id: number, userStatusUpdateRequest: UserStatusUpdateRequest, orgId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUserStatus', 'id', id)
            // verify required parameter 'userStatusUpdateRequest' is not null or undefined
            assertParamExists('updateUserStatus', 'userStatusUpdateRequest', userStatusUpdateRequest)
            const localVarPath = `/users/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orgId !== undefined) {
                localVarQueryParameter['__orgId__'] = orgId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userStatusUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new user.
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(createUserRequest: CreateUserRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(createUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the effective organization\'s user administration settings.
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgSettings(orgId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgSettings(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get detailed user information by ID.
         * @param {number} id User ID
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(id: number, orgId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(id, orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all users for the authenticated user\'s organization.
         * @param {number} [orgId] Overrides the organization context for org 1 admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(orgId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an existing user.
         * @param {number} id User ID
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(id: number, updateUserRequest: UpdateUserRequest, orgId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(id, updateUserRequest, orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enable or disable a user.
         * @param {number} id User ID
         * @param {UserStatusUpdateRequest} userStatusUpdateRequest 
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserStatus(id: number, userStatusUpdateRequest: UserStatusUpdateRequest, orgId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserStatus(id, userStatusUpdateRequest, orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new user.
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(createUserRequest: CreateUserRequest, options?: any): AxiosPromise<UserDetailResponse> {
            return localVarFp.createUser(createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the effective organization\'s user administration settings.
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgSettings(orgId?: number, options?: any): AxiosPromise<OrgSettingsResponse> {
            return localVarFp.getOrgSettings(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get detailed user information by ID.
         * @param {number} id User ID
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(id: number, orgId?: number, options?: any): AxiosPromise<UserDetailResponse> {
            return localVarFp.getUser(id, orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all users for the authenticated user\'s organization.
         * @param {number} [orgId] Overrides the organization context for org 1 admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(orgId?: number, options?: any): AxiosPromise<Array<UserListItemResponse>> {
            return localVarFp.listUsers(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing user.
         * @param {number} id User ID
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(id: number, updateUserRequest: UpdateUserRequest, orgId?: number, options?: any): AxiosPromise<UserDetailResponse> {
            return localVarFp.updateUser(id, updateUserRequest, orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable or disable a user.
         * @param {number} id User ID
         * @param {UserStatusUpdateRequest} userStatusUpdateRequest 
         * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStatus(id: number, userStatusUpdateRequest: UserStatusUpdateRequest, orgId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.updateUserStatus(id, userStatusUpdateRequest, orgId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Create a new user.
     * @param {CreateUserRequest} createUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createUser(createUserRequest: CreateUserRequest, options?: any) {
        return UsersApiFp(this.configuration).createUser(createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the effective organization\'s user administration settings.
     * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getOrgSettings(orgId?: number, options?: any) {
        return UsersApiFp(this.configuration).getOrgSettings(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get detailed user information by ID.
     * @param {number} id User ID
     * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUser(id: number, orgId?: number, options?: any) {
        return UsersApiFp(this.configuration).getUser(id, orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all users for the authenticated user\'s organization.
     * @param {number} [orgId] Overrides the organization context for org 1 admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public listUsers(orgId?: number, options?: any) {
        return UsersApiFp(this.configuration).listUsers(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing user.
     * @param {number} id User ID
     * @param {UpdateUserRequest} updateUserRequest 
     * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUser(id: number, updateUserRequest: UpdateUserRequest, orgId?: number, options?: any) {
        return UsersApiFp(this.configuration).updateUser(id, updateUserRequest, orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable or disable a user.
     * @param {number} id User ID
     * @param {UserStatusUpdateRequest} userStatusUpdateRequest 
     * @param {number} [orgId] Overrides the organization context for an authorized org 1 admin user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserStatus(id: number, userStatusUpdateRequest: UserStatusUpdateRequest, orgId?: number, options?: any) {
        return UsersApiFp(this.configuration).updateUserStatus(id, userStatusUpdateRequest, orgId, options).then((request) => request(this.axios, this.basePath));
    }
}
